import { useContext } from 'react';

import TenantContext from '../contexts/tenant';

const useTenant = () => useContext(TenantContext);

export default useTenant;
